import cookies from './cookies'

const TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const UUID_KEY = 'uuid'
const USER_NAME = 'username'

/**
 * 获取tonken
 */
export function getToken() {
    let r = cookies.get(TOKEN_KEY)
    // 开发模式使用默认 token , 这个 token 使用期限为永久
    console.log("process.env.NODE_ENV"+process.env.NODE_ENV)
    if (process.env.NODE_ENV.includes('dev') && !r) {
        return  '566h55CG5ZGashdcnbcY55qEdG9rZW4'
        // return null
    }
    return r
}

export function setToken(token, optins) {
    return cookies.set(TOKEN_KEY, token, optins)
}

